import classNames from 'classnames';
import styles from './Tabs.module.scss';

export type CallbackTab = {
  id: string;
  title: string;
  disabled?: boolean;
  onClick: (id: string) => void;
};

type CallbackTabsProps = {
  tabs: CallbackTab[];
  size?: 's' | 'm';
  className?: string | undefined;
};

export const CallbackTabs = ({ tabs, size = 'm', className }: CallbackTabsProps) => {
  return (
    <div className={classNames(styles['callback-tabs'], styles[`size-${size}`], className)}>
      <div className={styles.tabs}>
        {tabs.map((tab) => {
          return (
            <div key={tab.id} onClick={() => !tab.disabled && tab.onClick(tab.id)} className={styles.tab}>
              {tab.title}
            </div>
          );
        })}
      </div>
    </div>
  );
};
